// jQuery(function($){
jQuery(document).ready(function ($){
  
  $(window).scroll(function () {
    var header = $("#shopify-section-header");
    // var header2 = $("#shopify-section-m3-announcement-new");
    var header2 = $("#shopify-section-sliding-announcement-sticky");
    var scrolltop = $(document).scrollTop() + window.innerHeight; 
    if ($(window).scrollTop() > 60) {
      header.addClass("sticky_header_dk"); 
      header2.addClass("sticky_header_dk");
      if($('#shopify-section-m3-announcement-new').length){header.css({"top": "60px"});}else{header.css({"top": "0px"});}
      // if($('#shopify-section-sliding-announcement-sticky').length){header.css({"top": "60px"});}else{header.css({"top": "0px"});}
    } else {
      header.removeClass("sticky_header_dk");
      header2.removeClass("sticky_header_dk");
    }  

    if (jQuery(window).width() <= 768) {
      if ($(window).scrollTop() > 60) {
        if($('#shopify-section-m3-announcement-new').length){header.css({"top": "85px"});}else{header.css({"top": "0px"});}
        // if($('#shopify-section-sliding-announcement-sticky').length){header.css({"top": "60px"});}else{header.css({"top": "0px"});}
      }
    }
  });
  
  // jQuery('div#s-0c77de9f-0146-45e4-bec3-679c66fa29b7 .shg-gallery-thumb-image-wrapper').owlCarousel({
  //      loop: true,
  //      margin: 20,
  //      nav: false,
  //      dots: false,
  //      autoplay: true,
  //      autoplayHoverPause: true,
  //      responsive: {
  //            0: {
  //               items: 5
  //            },
  //            600: {
  //               items: 5
  //            },
  //            1000: {
  //               items: 5
  //            }
  //      }
  //   });
  
  $(".claim-now-btn .shg-btn").click(function() {
      $('html, body').animate({
          scrollTop: $(".tech-section-main").offset().top
      }, 100);
  });

  
  $('.tel-btn').attr('href','tel:1300 054 055');
  $('.tel-btn').attr('title','tel:1300 054 055');
  $('.tel-btn').find('.telphone').text('- 1300 054 055');
  var pathname = window.location.pathname;
  if(pathname == '/collections/zero-gravity-massage-chair'){
    $('div#shopify-section-template--15798594011335__product-grid').hide();
  }
  $('.hide-show-description .masproduct-detail').hide();
  $('a#s-a9790a7a-1ea5-4c2f-82a5-329345967a4c , .toogle-btn , a#s-44c48da2-36ac-497f-928b-1f8e031ce2b9').click(function() {
    $('.toogle-btn').hide();
    $('.hide-show-description .masproduct-detail , .toogle-sections').slideToggle();
  });

  $('h2.footer-block__heading').click(function() {
    $(this).siblings("ul.footer-block__details-content").toggle();
  });

  /*---------Mega menu----------*/
  $('.mega-menu').each(function(){
    var submenu = $(this).data('dropdown');
    $('.submenu--'+submenu).remove();
  });
  $('.mainMenu > .dropdown').on('mouseenter touchstart', function(){
    var elemSelector =$(this).find('.mainMenu__link').data('dropdown-rel');
    $('.dropdown_container').not('[data-dropdown="'+elemSelector+'"]').hide();
    $('[data-dropdown="'+elemSelector+'"]').show();
  });
 
  $('.dropdown_container').on('mouseleave', function(){
    $('.dropdown_container').hide();
  });
  
  $('.announcementBar').on('mouseenter', function(){
    $('.dropdown_container').hide();
  });

  // $('.team-img-gallery .shogun-image-container').on('mouseenter', function(){
  //     console.log("Hiii");
  //     $(this).siblings('.membersname').css({"position": "absolute", "opacity": "1"});
  // });

  // $('.team-img-gallery .shogun-image-container').on('mouseleave', function(){
  //     console.log("Hiii");
  //     $(this).siblings('.membersname').css({"position": "relative", "opacity": "0"});
  // });
 
  /*-----Maintaining banner below header------*/
  $('.shapesOverflow').css({'margin-top': ($('.sticky_header').height())+'px'});
  $('.mega-menu .menu').css({'top': $('.sticky_header').height()+'px'});
  $(window).resize(function(){
    $('.shapesOverflow').css({'margin-top': ($('.sticky_header').height())+'px'});
  $('.mega-menu .menu').css({'top': $('.sticky_header').height()+'px'});
  });
  
  $('.js-close-announcement').on('click', function(){
    // $('.mega-menu .menu').css({'top': $('.sticky_header').height()+'px'});
    // $('.shapesOverflow').css({'margin-top': ($('.sticky_header').height())+'px'});
    $('div#shopify-section-m3-announcement-new').remove();
  });
  
  /*-------Mega menu mobile--------*/
  // $('.mega-menu-container .mobile-mega-menu').each(function(index){
  //     //$('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
  //     $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr('data-no-instant', 'true');
  //     $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
  //     $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
  //     $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
  //       $(this).removeClass('hidden');
  //       if (!$(this).hasClass('mobile-mega-menu')) {
  //         //$(this).remove();
  //       }
  //     });
     
  //   });

  $('.mega-menu-container .mobile-mega-menu').each(function(index){
    console.log("HERERERER")
      //$('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr('data-no-instant', 'true');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
        $(this).removeClass('hidden');
        if (!$(this).hasClass('mobile-mega-menu')) {
          $(this).remove(); //readded by m3 29/03/21 - need to add custom dropdown, toggle selects first ul available
        }
      });
     
    });
  
  $('.whyus .textColumn__blocks').append('<div class="showall"><span>show all the details +</span></div>');
  $('.showall span').click(function() {
    if($(this).hasClass('expand')) {
      	$(this).removeClass('expand');
      	$('.whyus .textColumn__text').slideUp(200);
      	$('.whyus-product-content p').slideUp(200);
      	$(this).text('show all the details +');
    } else {
      	$(this).addClass('expand');
 		$('.whyus .textColumn__text').slideDown(200);
      	$('.whyus-product-content p').slideDown(200);
      	$(this).text('hide all the details +');
    }
  }); 
  
  /*------ Text column accordian -------*/  
  /*
  $( '.content-trigger' ).click(function() {
    $(this).next().slideToggle(200);
    return false;
  }); 
  */
  
  $('.main-box .image-box .box-one').each(function(){
    $(this).insertAfter($(this).next());
  });
  
  $(document).ready(function (){
            $("#zipmoney").click(function (){
                $('html, body').animate({
                    scrollTop: $("#shopify-zip-product-widget").offset().top
                }, 1000);
            });
    
            $("#certegy").click(function (){
                $('html, body').animate({
                    scrollTop: $("#certegy-write-up").offset().top
                }, 1000);
            });
    
    		$(".teams__more-link").click(function (){
                $('html, body').animate({
                    scrollTop: $("#team-member").offset().top - $(".sticky_header").innerHeight()
                }, 1000);
            });
    
    	$('.our-team .logoBar__content').wrapInner('<div class="owl-carousel"></div>');
    	$('.our-team-product').wrapInner('<div class="owl-carousel"></div>');
    	
    	$('.our-team .logoBar__content .owl-carousel').owlCarousel({	
            autoplay: true,
            slideTransition: 'linear',
            autoplayTimeout : 4000,
            autoplayHoverPause : false,
            autoplaySpeed : 4000,
    		    dots: false,
          	loop: true,
            margin: 20,
			      nav: false,
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 4
                },
                1000: {
                    items: 5
                }
            }
      });

      // Testimonials page video slider
      $('.video-carousel .media-wrapper.owl-carousel').owlCarousel({
        items:1,
        // merge:true,
        stagePadding: 50,
        margin: 10,

        lazyload:true,
        center: false,
        dots: true,
        nav: true,
        loop: false,
        rewind: true,
        responsive: {
          600: {
            items: 2
          }
      }
      });
    
    	$('.our-team-product .owl-carousel').owlCarousel({	
            autoplay: true,
            slideTransition: 'linear',
            autoplayTimeout : 4000,
            autoplayHoverPause : false,
            autoplaySpeed : 4000,
    		    dots: false,
          	loop: true,
            margin: 30,
			      nav: false,
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 4
                },
                1000: {
                    items: 5
                }
            }
        });
    
        $('.accordion-technology .accordion__header').click(function(){
            var activeimg = $(this).attr('id');
            $('.img-technology').hide();
            $('.'+activeimg).show();
          });
    
        if($('.specifications-fit').length) {
			$('.specifications-fit').appendTo('.shopify-product-form');
        }
    
    	countDown();
		var countdown = setInterval(countDown, 1000);

		function countDown()
		{
			day_today=moment().format("DD");
          	month_today=moment().format("MM");
          	year_today=moment().format("YYYY");
          
          	if(day_today % 3 ==0)
          		var future = moment( year_today+'-'+month_today+'-'+day_today+'T23:59:59.000Z');
          else{
            //find next day mod by 3
            if(day_today==31) day_today=1;
            if(month_today==02)
            {	
              if((day_today==28) || (day_today==29))
                day_today=1;
            }
            day_future=day_today;
            while (day_future % 3!=0)            {
              
              day_future++;
            }
            
            diff=day_future-day_today;
            
            future_date=moment().add(diff,'days');            
            day_future=moment().format("DD");
          	month_future=moment().format("MM");
          	year_future=moment().format("YYYY");
            
            //console.log(day_today);
            
              	var future = moment( year_future+'-'+month_future+'-'+day_future+'T23:59:59.000Z');
          }
          
			var now = moment();

			var _widget = document.getElementById( 'timer-widget-' + '212' );
          
          if(!_widget) return

			var days_elem = 	_widget.getElementsByClassName( 'days' )[0].getElementsByTagName( 'span' )[0];
			var hours_elem = 	_widget.getElementsByClassName( 'hours' )[0].getElementsByTagName( 'span' )[0];
			var minutes_elem = 	_widget.getElementsByClassName( 'minutes' )[0].getElementsByTagName( 'span' )[0];
			var seconds_elem = 	_widget.getElementsByClassName( 'seconds' )[0].getElementsByTagName( 'span' )[0];
			var delta = 		Math.abs( future - now ) / 1000;
			var days = 0;
			var hours = 0;
			var minutes = 0;
			var seconds = 0;

			if( future - now <= 0 )
			{
				clearInterval(countdown);
			}
			else
			{
				days = Math.floor( delta / 86400 );
				delta -= days * 86400;

				hours = Math.floor( delta / 3600 ) % 24;
				delta -= hours * 3600;

				minutes = Math.floor( delta / 60 ) % 60;
				delta -= minutes * 60;

				seconds = Math.floor( delta % 60 );
			}
			days_elem.innerHTML = 		formatDigits( days, 2 );
			hours_elem.innerHTML = 		formatDigits( hours, 2 );
			minutes_elem.innerHTML = 	formatDigits( minutes, 2 );
			seconds_elem.innerHTML = 	formatDigits( seconds, 2 );

			function formatDigits( value, digits_number )
			{
				if ( value.toString().length < digits_number )
				{
					return ( new Array( digits_number - value.toString().length + 1 ).join( '0' ) ) + value;
				}
				else
				{
					return value;
				}
			}
		}
  });
//google tag tracking
  $("#contact_form .submit").on('click', function() {
  console.log('contact clicked');
  	dataLayer.push({'event': 'button-contact-us-clicked'});
  });
//end of google tag tracking
$('table#google_reviews tr:first').addClass('active');

  $('.hellobar-phonecall').click(function(){
      ga('send', 'event', 'Phone Number', 'Clicked', 'Hellobar Phone Call', 1);
  });

  
$('a.reviews_load_more').on('click', function(e) {
  e.preventDefault();  
  var $rows = $('table#google_reviews tr');
  var lastActiveIndex = $rows.filter('.active:last').index();
  $rows.filter(':lt(' + (lastActiveIndex + 2) + ')').addClass('active');
});

  $('area.tooltipstered').click(function(){ return false; });
   
  $('#moneymarket').on('click', function(e) {
	e.preventDefault();
    var position = $("#ourmoneymarket").offset().top; 
    $('html, body').animate({ scrollTop: position }, 2000);
  });
  
  $('.__pf a[href^="#"]').each(function(){
	$(this).click(function(e){
	e.preventDefault();
    var target = $(this).attr('href');
	var position = $(target).offset().top - $('.sticky_header').height();
      if(position) {
		$('html, body').animate({
		scrollTop: position }, 2000);
      }
	});
  });
  
  $('#c-submit-button').click(function(){
    var position = $('.cognito').offset().top - $('.sticky_header').height();
      if(position) {
		$('html, body').animate({
		scrollTop: position }, 400);
      }
  });
  
  $(document).on('afterSubmit.cognito', function(e, data) {
    var position = $('.cognito').offset().top - $('.sticky_header').height();
    if(position) {
		$('html, body').animate({
		scrollTop: position }, 400);
    }
  });
  
  function postsCarousel() {
		var checkWidth = $(window).width();
		var owlPost = $(".whyus-product-content");
		if (checkWidth > 481) {
			if(typeof owlPost.data('owl.carousel') != 'undefined'){
				owlPost.data('owl.carousel').destroy(); 
			}
			owlPost.removeClass('owl-carousel');
		} else if (checkWidth < 480) {
			owlPost.addClass('owl-carousel');
			owlPost.owlCarousel({
				items : 1,
				dots: true,
				margin: 0,
				nav: false
			});
		}
	}

	postsCarousel();
	$(window).resize(postsCarousel);
});